<template>
    <div id="vacancies" class="container pt-5 pb-5 page">
        <!--
        <h2 class="mb-5">VACATURE: Commerciële & Ondernemende Beveiligings Manager</h2>
        <h3>Omschrijving</h3>
        <p>Azurity zoekt een ondernemende commerciële manager met operationele beveiligings ervaring.</p>
        <p>Je bent ondernemend ingesteld, weet nieuwe opdrachten en klanten binnen te halen en kan operationeel leidinggeven. 
            Opstellen van beveiligingsplannen en de gewenste behoefte afstemming met de klanten. 
            Je hebt gevoel voor dienstverlening, kan je vinden in de drijfveren van Azurity. Daarnaast wil je graag meegroeien met ons bedrijf
            en bent bereid om op basis van een prestatiebeloning te werken. Ben je succesvol, dan wordt je er ook naar beloond.
        </p>
        <p>Je werkt direct samen met de Algemeen Directeur en IT-Manager.</p>
        <h3>Wat vragen we?</h3>
        <ul>
            <li>HBO werk- en denk niveau;</li>
            <li>Je bent ondernemend en creatief;</li>
            <li>Je bent commercieel en communicatief sterk;</li>
            <li>Je hebt passie voor veiligheid en beveiliging en hebt up-to-date kennis van de branche;</li>
            <li>Je wilt graag meegroeien met Azurity en kan/wil de werkzaamheden in het begin part-time invullen. Eventueel flexibel naast een andere baan mogelijk;</li>
            <li>Je woont en werkt in de omgeving Leiden / Oegstgeest;</li>
            <li>Diploma MBO-2 Beveiliger of gelijkwaardig is een pré;</li>
        </ul>
        <h3>Procedure</h3>
        <p>We verwachten geen uitgebreide sollicitatie brieven. Heb je interesse stuur dan een email naar <a href="info@azurity.nl">info@azurity.nl</a>. 
        Het eerste interview zal telefonisch gaan, waarna een persoonlijk gesprek zal plaatsvinden. Wij staan altijd open voor een bak koffie en een goed gesprek.</p>
        <hr class="mt-5 mb-5">
        -->
        <div class="row">
            <div class="col-md-12">
                <h1>Kom bij ons werken!</h1>
                <p>
                    Regelmatig zijn wij opzoek naar nieuwe <router-link tag="a" :to="{ name: 'InformationProfessional' }">professionals</router-link>, zowel ZZP, dienstverband bij ons of zo nu en dan een klus via je eigen werkgever. 
                    Je bepaalt bij ons zelf wat je wilt gaan verdienen en wanneer je wilt werken.
                    <router-link tag="a" :to="{ name: 'RegisterProfessional' }">Registreer</router-link> je vandaag nog op Azurity!
                </p>
                <hr />
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <h2>Beveiliger</h2>
                <p>Om <router-link tag="a" :to="{ name: 'InformationSecurity' }">beveiliger</router-link> bij Azurity te worden, dien je je aan te melden als beveiliger.</p>
                <register-button-pro type="beveiliger"></register-button-pro>
                <hr class="mt-5 mb-5">
            </div>
            <div class="col-md-3">
                <h2>Verkeersregelaar</h2>
                <p>Om <router-link tag="a" :to="{ name: 'InformationTrafficSupport' }">verkeersregelaar</router-link> bij Azurity te worden, dien je je aan te melden als Verkeersregeleaar.</p>
                <register-button-pro type="verkeersregelaar"></register-button-pro>
                <hr class="mt-5 mb-5">
            </div>
            <div class="col-md-3">
                <h2>Brandwacht</h2>
                <p>Om brandwacht bij Azurity te worden, dien je je aan te melden als brandwacht.</p>
                <register-button-pro type="brandwacht"></register-button-pro>
                <hr class="mt-5 mb-5">
            </div>
            <div class="col-md-3">
                <h2>EHBO-er</h2>
                <p>Om <router-link tag="a" :to="{ name: 'InformationFirstAid' }">EHBO-er</router-link> bij Azurity te worden, dien je je aan te melden als EHBO-er.</p>
                <register-button-pro type="EHBO-er"></register-button-pro>
                <hr class="mt-5 mb-5">
            </div>
            <div class="col-md-12 text-center">
                <p>Voor open sollicitaties of vragen mail naar: <a href="mailto:werkenbij@azurity.nl">werkenbij@azurity.nl</a>.</p>
            </div>
        </div>
    </div>
</template>

<script>
import RegisterButtonPro from '@/components/RegisterButtonPro';
export default {
    components: {
        RegisterButtonPro
    }
}
</script>